import UseApiService from "./apiService";
import { API_ENDPOINTS, FALLBACK, REACT_APP_SWAN_API_SERVER_URL, TOKEN_DATA_TYPE } from "./constant";
import swan from "./swanservice";
const baseUrl = REACT_APP_SWAN_API_SERVER_URL
class ProductService{
    handleProductUrlParse(productUrl) {
		const body = {
			url: baseUrl+API_ENDPOINTS.tryon.tryonProductMetadata,
			data: { productUrl },
			headerToken: TOKEN_DATA_TYPE.ACCESS,
		};
		return UseApiService.post(body);
	}

	handleTimeout(ref, fallBack) {
		const timeRef = setTimeout(() => {
			ref?.close();
			fallBack?.();
		}, 60000);
		return timeRef;
	}
    handleWebsocketProductImageCheck(params) {
		let timeRef;
		const url = `${REACT_APP_SWAN_API_SERVER_URL}${API_ENDPOINTS.tryon.tryonProductCheckWebsocket}?openTryonId=${params.openTryonId}`;
		const socket = new WebSocket(url);
		socket.onopen = () => {
			params?.onOpen?.();
			timeRef = this.handleTimeout(socket, () => {
					this.urlParsingFallback({ openTryonId: params?.openTryonId, onSuccess: params?.onSuccess, onError: params?.onError });
			});
		};
		socket.onmessage = (event) => {
			clearTimeout(timeRef);
			try {
				const data = JSON.parse(event.data);
				params?.onSuccess?.(data);
			} catch (error) {
				console.error("Invalid message format:", event.data);
			}
		};
		socket.onclose = () => {
			params?.onClose?.();
		};
		socket.onerror = (event) => {
            params?.onError?.(event);
			console.log(event);
		};
	}
    async urlParsingFallback({openTryonId,onSuccess,onError}) {
		try {
			const structureRes = await this.tryonProductStructure(openTryonId);
			if (structureRes?.data?.errorCode) {
				onError?.(structureRes?.data);
				return;
			}
			const imageRes = await this.tryonUrlProductImage(openTryonId);
			onSuccess?.({
				structureRes: structureRes?.data,
				imageRes: imageRes?.data,
				messageType: FALLBACK,
			});
		} catch (error) {
			onError?.(error);
		}
	}
	getShareableLink(tryonId) {
		return swan.tryOn.getShareLink(tryonId);
	}
	handleProductShareFeedback(params) {
		const body = {
			url: baseUrl+API_ENDPOINTS.tryon.tryonProductShareFeedback,
			data: params,
			headerToken: TOKEN_DATA_TYPE.ACCESS,
		};
		return UseApiService.post(body);
	}
}

const productService = new ProductService();
export default productService